import Vue from "vue";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-40099813-3" }
});
// export default new VueGtag({}); FAILS
